import axios from "@/plugins/axios"
import type { PurchaseProduct } from "@/types/purchase-product.type"

export interface UpdatePickupAtRequest {
  pickupAt: string
}

export interface ConfirmRequest {
  pickupAt: string
  offPrice: number | null
  deliveryMethod: string
}

export interface FailRequest {
  failureReason: string
  extendedLeadtime: number | null
  stockQuantity: number | null
  risenUnitPrice: number | null
  productionMoq: number | null
  productionLeadtime: number | null
}

export interface DeliveryRequest {
  purchaseProductIds: number[]
  shipper: string | null
  trackingCode: string | null
  trackingLink: string | null
}

async function get(id: number): Promise<PurchaseProduct> {
  const response = await axios.get<PurchaseProduct>(`/purchase_products/${id}`)
  return response.data
}

async function getConfirmedList(): Promise<PurchaseProduct[]> {
  const response = await axios.get<PurchaseProduct[]>("/purchase_products/confirmed_list")
  return response.data
}

async function getDeliveryRequestedList(): Promise<PurchaseProduct[]> {
  const response = await axios.get<PurchaseProduct[]>("/purchase_products/delivery_requested_list")
  return response.data
}

async function updatePickupAt(id: number, request: UpdatePickupAtRequest): Promise<PurchaseProduct> {
  const response = await axios.put<PurchaseProduct>(`/purchase_products/${id}/pickup_at`, request)
  return response.data
}

async function confirm(id: number, request: ConfirmRequest): Promise<PurchaseProduct> {
  const response = await axios.put<PurchaseProduct>(`/purchase_products/${id}/confirm`, request)
  return response.data
}

async function fail(id: number, request: FailRequest): Promise<PurchaseProduct> {
  const response = await axios.put<PurchaseProduct>(`/purchase_products/${id}/fail`, request)
  return response.data
}

async function delivery(request: DeliveryRequest): Promise<PurchaseProduct> {
  const response = await axios.put<PurchaseProduct>(`/purchase_products/request_deliveries`, request)
  return response.data
}

const purchaseProductService = {
  get,
  getConfirmedList,
  getDeliveryRequestedList,
  updatePickupAt,
  confirm,
  fail,
  delivery,
}

export default purchaseProductService
